import { isFeature } from 'Cloud/Application/FeaturesEs6';
import config from 'Cloud/config';
import { ADD_TOOLBAR_ID, HEADER_ID, REACT_VIEWER_ID, TOP_TOOLBAR_ID } from 'reactApp/constants/magicIdentificators';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { chooseVariant } from 'reactApp/modules/features/features.helpers';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';

export const IS_PUBLIC_SHOVE = config.get('PUBLIC_SHOVE');
export const IS_NEW_PDF_PUBLIC = isFeature('new-pdf-public');

export const SECOND_CLICK_TIP_KEY = 'show-second-click-tip';
export const SECOND_CLICK_TIP_HOME_KEY = 'show-second-click-tip-home';
export const SECOND_CLICK_TIP_PUBLIC_KEY = 'show-second-click-tip-public';
export const SECOND_CLICK_TIP_QUOTA_CLEANER_KEY = 'show-second-click-tip-quota-cleaner';

// tempexp_14728-next-line
export const ROW_HEIGHT = chooseVariant(getFeatureNewContentGrid, { control: 48, variant1: 56 });

export const gaHotkeyCategory = 'datalist-hotkey';

export const HOT_KEY_SCOPE_NAME = 'datalist';

export const TAGNAME_NO_RESET_WHITE_LIST = {
    input: true,
    textarea: true,
    a: true,
    button: true,
};

export const IDS_NO_RESET_WHITE_LIST = {
    cloud_toolbars: true,
    tipClose: true,
    dropdownList: true,
    [TOP_TOOLBAR_ID]: true,
    [ADD_TOOLBAR_ID]: true,
    [REACT_VIEWER_ID]: true,
    [HEADER_ID]: true,
    preview: true,
};

export const leaderKey = EnvironmentSelectors.isMac() ? 'cmd' : 'ctrl';

export const isMobile = EnvironmentSelectors.isMobile() || EnvironmentSelectors.isIpadOs();
